import React, { useState, useEffect } from 'react';
import '../../Component/Header/Header.css';
import './AIheaderstyle.css'
import BetaForm from '../../Component/BetaForm';
import useHeaderScroll from '../../hooks/useHeaderScroll';
import { Link, useLocation} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const Aiheader = () => {

    const location = useLocation();
   const pathname = location.pathname;

    // Glass at the top of the page, black once scrolled past half the first screen; never hides.
    const scrolled = useHeaderScroll();

        
            const resetSubmenuState = () => {
                // Reset submenu container
                const submenuContainer = document.getElementById('submenu-container');
                if (submenuContainer) {
                    submenuContainer.classList.remove('showsub');
                    submenuContainer.classList.add('hide');
                }
                
                // Hide all submenus
                const submenus = document.querySelectorAll('.submenu');
                submenus.forEach(submenu => {
                    submenu.style.display = 'none';
                    submenu.style.transform = 'translateX(100%)';
                });
                
                // Show the main menu
                const mainMenu = document.querySelector('.mobile-header .menu');
                if (mainMenu) {
                    mainMenu.style.display = 'block';
                }
            };
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("signup") === "beta-program") {
            const modalElement = document.getElementById("exampleModal");
            if (modalElement) {
                if (window.bootstrap && window.bootstrap.Modal) {
                    new window.bootstrap.Modal(modalElement).show();
                }
            }
        }else if(urlParams.get("signup") === "waitlist"){
            // Legacy waitlist signup links now go to the app sign-up page.
            window.location.href = "https://app.rentid.io/sign-up";
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Close an open mega menu when the user clicks the dimmed overlay (the dropdown element itself
    // covers the viewport, so Bootstrap's auto-close="outside" never fires) or presses Escape.
    useEffect(() => {
        const closeOpenMega = () => {
            document.querySelectorAll('.dropdown-menu.open-full-mega.show').forEach((menu) => {
                const toggle = menu.parentElement && menu.parentElement.querySelector('[data-bs-toggle="dropdown"]');
                const Dropdown = window.bootstrap && window.bootstrap.Dropdown;
                if (toggle && Dropdown) {
                    (Dropdown.getInstance(toggle) || new Dropdown(toggle)).hide();
                } else {
                    menu.classList.remove('show');
                    if (toggle) { toggle.classList.remove('show'); toggle.setAttribute('aria-expanded', 'false'); }
                }
            });
        };
        const onClick = (e) => {
            const target = e.target;
            if (target.classList && target.classList.contains('open-full-mega') && target.classList.contains('show')) {
                closeOpenMega();
            }
        };
        const onKey = (e) => { if (e.key === 'Escape') closeOpenMega(); };
        document.addEventListener('click', onClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('click', onClick);
            document.removeEventListener('keydown', onKey);
        };
    }, []);

    const additionalClass = scrolled ? 'scrolled' : '';
    const visibilityClass = 'visible';
    

    const [isToggled, setIsToggled] = useState(false);

    const handleToggle = () => {
        setIsToggled((prev) => !prev);

        // If opening the menu, reset to root level
        if (!isToggled) {
            resetSubmenuState();
        }
    };

    
    useEffect(() => {
        if (isToggled) {
            // Add bodyFilter class to prevent body scroll
            document.body.classList.add('bodyFilter');
            
            // Add scroll class to menu elements
            const desktopMenu = document.getElementById("navbarSupportedContent");
            const mobileMenu = document.getElementById("navbarSupportedContentmob");
            
            if (desktopMenu) {
                desktopMenu.classList.add("menu-scroll-enabled");
                // iOS Safari specific: force reflow
                desktopMenu.style.webkitTransform = 'translate3d(0, 0, 0)';
            }
            if (mobileMenu) {
                mobileMenu.classList.add("menu-scroll-enabled");
                // iOS Safari specific: force reflow
                mobileMenu.style.webkitTransform = 'translate3d(0, 0, 0)';
            }
            
            // iOS Safari specific: prevent body scroll more aggressively
            const originalBodyStyle = document.body.style.cssText;
            document.body.style.cssText += '; -webkit-overflow-scrolling: touch; -webkit-transform: translate3d(0, 0, 0);';
            
            return () => {
                document.body.style.cssText = originalBodyStyle;
            };
        } else {
            // Remove bodyFilter class
            document.body.classList.remove('bodyFilter');
            
            // Remove scroll class from menu elements
            const desktopMenu = document.getElementById("navbarSupportedContent");
            const mobileMenu = document.getElementById("navbarSupportedContentmob");
            
            if (desktopMenu) {
                desktopMenu.classList.remove("menu-scroll-enabled");
                desktopMenu.style.webkitTransform = '';
            }
            if (mobileMenu) {
                mobileMenu.classList.remove("menu-scroll-enabled");
                mobileMenu.style.webkitTransform = '';
            }
        }

        // Cleanup on unmount
        return () => {
            document.body.classList.remove('bodyFilter');
            const desktopMenu = document.getElementById("navbarSupportedContent");
            const mobileMenu = document.getElementById("navbarSupportedContentmob");
            
            if (desktopMenu) {
                desktopMenu.classList.remove("menu-scroll-enabled");
                desktopMenu.style.webkitTransform = '';
            }
            if (mobileMenu) {
                mobileMenu.classList.remove("menu-scroll-enabled");
                mobileMenu.style.webkitTransform = '';
            }
        };
    }, [isToggled]);

    const navigate = useNavigate();

        // Function to handle navigation
        const handleNavigation = (section) => {
            if (location.pathname !== "/") {
                navigate("/", { state: { scrollTo: section } });
            } else {
                scrollToSection(section);
            }
        };

        // Function to scroll to section
        const scrollToSection = (section) => {
            setTimeout(() => {
                const element = document.getElementById(section);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 300);
        };
    return (
        <div className={`${additionalClass} ${visibilityClass}`}>

        {/* START header */}
        {/* <header id=" " className="headerWhite">  */}
        <header id="header" className={`header headerWhite d-flex align-items-center fixed-top home-header-inner ${
    pathname !== "/getaround" ? "home-header-inner-top" : ""
  }`}> 
        <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <a className="navbar-brand" href="/">
                    <img src="/img/Rentid-white.svg" alt="Rentid logo" className="desktopLogo inner-desktop-logo"/>
                    <img src="/img/Rentid-white.svg" alt="Rentid logo" className="mobileLogo" />
                </a>

                <ul className="navbar-nav ms-auto d-none outside-btns">
                        <li className="nav-item nav-itemBtn">
                            <Link to="https://app.rentid.io/sign-up" className="btn joinWaitBtn">Start for free</Link>
                        </li>
                        {/* <li className="nav-item nav-itemBtn">
                            <button className="btn getStartedBtn" onClick={() => {
                                navigate('/?signup=beta-program')
                            }}>Join Beta</button>
                        </li> */}

                        <li className="nav-item dropdown ">
                            <a className="loginbtn login-icon nav-link" href="https://app.rentid.io/login" aria-label="Login" title="Login"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg></a>
                        </li>
                    </ul>
                       <div className="nav-btn mobile-nav-logo">
                                                <a href="/"><img src="/img/Rentid-white.svg" alt="mobile logo" className="mobileLogo" /></a>
                                              <ul className="navbar-nav ms-auto d-none outside-btns">
                                                    
                                                    {/* {process.env.REACT_APP_ENABLE_BETA === "true" && (
                                                        <li className="nav-item nav-itemBtn">
                                                            <button className="btn getStartedBtn" data-bs-toggle="modal" data-bs-target="#exampleModal">Join Beta</button>
                                                        </li>
                                                    )} */}
                                                         <li className="nav-item dropdown login-btn">
                                                        <a className="loginbtn login-icon nav-link" href="https://app.rentid.io/login" aria-label="Login" title="Login"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg></a>
                                                    </li>
                    
                                <li className="nav-item nav-itemBtn">
                                    <Link to="https://app.rentid.io/sign-up" className="btn joinWaitBtn">Start for free</Link>
                                </li>
                                                </ul>
                                                </div>
                <button id="navbarTogglerButton" className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded={isToggled} aria-label="Toggle navigation" onClick={handleToggle}>
                    <span className="navbar-toggler-icon"></span>
                    <i className={`bi ${isToggled ? "bi-x" : "bi-list"}`}></i>
                </button>
                <div className="collapse navbar-collapse desktop-header" id="navbarSupportedContent">
                
                    <div className="nav-btn">
                                             
                    <a href="/"> <img src="/img/Rentid-white.svg" alt="desktop logo" className="scrolled-logo d-none" /></a>
                                             <ul className="navbar-nav ms-auto d-none outside-btns">
                                                   
                                                   {/* {process.env.REACT_APP_ENABLE_BETA === "true" && (
                                                       <li className="nav-item nav-itemBtn">
                                                           <button className="btn getStartedBtn" data-bs-toggle="modal" data-bs-target="#exampleModal">Join Beta</button>
                                                       </li>
                                                   )} */}
                                                   <li className="nav-item dropdown">
                                                       <a className="loginbtn login-icon nav-link" href="https://app.rentid.io/login" aria-label="Login" title="Login"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg></a>
                                                   </li>
                   
                                <li className="nav-item nav-itemBtn">
                                    <Link to="https://app.rentid.io/sign-up" className="btn joinWaitBtn">Start for free</Link>
                                </li>
                                               </ul>
                                               </div>
                      
                    <ul className="navbar-nav main-menu-mega">
                                 
                                 <li className="nav-item dropdown">
                                     <a className="loginbtn nav-link product-links-menus dropdown-toggle" href="/"  role="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                         Products
                                         <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> 
                                         <img src="/img/blue-icon.svg" className="blue-icon-drop" alt="icon" /> 
                                     </a>
                                 
                                     <div className="dropdown-menu open-full-mega" aria-labelledby="navbarDropdown">
                                       <ul className="phone-menu" >
                                         <li>
                                             <a href='/rentdirect'><button className="dropdown-item" type="button">
                                                 <img src='/img/rent_direct_h.svg' alt="icon" width={24} />
                                                 <div className="drop-content-item"><span>rent</span>direct <p>Every aspect of vehicle rental, fully automated.</p></div>
                                                 </button>
                                             </a>
                                         </li>
                                         <li>
                                             <a href='/rent-id'><button className="dropdown-item" type="button">
                                                   
                                                   <img src='/img/rent_id_h.svg' alt="icon" width={24} />
                                                   <div className="drop-content-item"> <span>rent</span>ID
                                                   <p>Trust & safety tools to minimize rental risk.</p>
                                                   </div>
                                                   </button>
                                                
                                             </a>
                                         </li>
                                         <li>
                                             <a href='/rentshield'><button className="dropdown-item" type="button">
                                                 
                                                
                                                  <img src='/img/rent_shield_h.svg' alt="icon" width={24} />
                                                  <div className="drop-content-item"> <span>rent</span>shield
                                                   <p>Embedded insurance and protection plans.</p>
                                                   </div>
                                                 </button>
                                             </a>
                                         </li>
                                         <li>
                                             <a href='/rentai'><button className="dropdown-item" type="button">
 
                                                   
                                                    <img src='/img/rent_ai_h.svg' alt="icon" width={24} />
                                                    <div className="drop-content-item"> <span>rent</span>AI
                                                    <p>Done for you rental tasks & workflows</p>
                                                   </div>
 
                                                </button>
                                             </a>
                                         </li>
                                         <li>
                                             <a href='/rentsuccess'>
                                             <button className="dropdown-item" type="button">
                                                   
                                                   <img src='/img/rent_success_h.svg' alt="icon" width={24} />
                                                   <div className="drop-content-item"> 
                                                   <span>rent</span>success
                                                    <p>Support, resolutions, & customer satisfaction.</p>
                                                   </div>
                                                 </button>
                                             </a>
                                         </li>
                                         <li>
                                             <a href='/rentacademy'>
                                                 <button className="dropdown-item" type="button">
                                                  <img src='/img/rent_academy_h.svg' alt="icon" width={24} />
                                                  <div className="drop-content-item"> <span>rent</span>academy
                                                    <p>Drive growth, maximize potential, & stay informed.</p>
                                                   </div>
                                                 </button>
                                             </a>
                                         </li>
                                       </ul>
                                        <div className="full-mega-menu">  
                                            <div className="custom-menu">
                                                <div className="container">
                                                    <div className="megamenu">
                                                        <div className="menu-left">
                                                            <h2>Products</h2>
                                                            <ul>
                                                                <li data-target="tab-1" className="active">
                                                                    <a href="/rentdirect" className="active">
                                                                        <img src="/img/rent_direct_icon.svg" alt=''/>
                                                                        <div className="menu-text">
                                                                            <h3><span>rent</span>direct</h3>
                                                                            <p>Every aspect of vehicle <br/> rental, fully automated.</p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                                <li data-target="tab-2">
                                                                    <a href="/rent-id">
                                                                        <img src="/img/rent_id_icon.svg" alt=''/>
                                                                        <div className="menu-text">
                                                                            <h3><span>rent</span>ID</h3>
                                                                            <p>Trust & safety tools <br/> to minimize rental risk.</p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                                <li data-target="tab-3">
                                                                    <a href="/rentshield">
                                                                        <img src="/img/rent_shield_icon.svg" alt=''/>
                                                                        <div className="menu-text">
                                                                            <h3><span>rent</span>shield</h3>
                                                                            <p>Embedded insurance <br/>and protection plans.</p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                                <li data-target="tab-4">
                                                                    <a href="/rentai">
                                                                        <img src="/img/rent_ai_icon.svg" alt=''/>
                                                                        <div className="menu-text">
                                                                            <h3><span>rent</span>AI</h3>
                                                                            <p>Rental tasks & workflows <br/> engineered to be stress free</p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                                <li data-target="tab-5">
                                                                    <a href="/rentsuccess">
                                                                        <img src="/img/rent_success_icon.svg" alt=''/>
                                                                        <div className="menu-text">
                                                                            <h3><span>rent</span>success</h3>
                                                                            <p>Support, resolutions,<br/> & customer satisfaction.</p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                                <li data-target="tab-6">
                                                                    <a href="/rentacademy">
                                                                        <img src="/img/rent_academy_icon.svg" alt=''/>
                                                                        <div className="menu-text">
                                                                            <h3><span>rent</span>academy</h3>
                                                                            <p>Drive growth, maximize <br/> potential, & stay informed.</p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
    
                                                        <div className="menu-right">
                                                            <div id="tab-1" className="menu-right-tab active">
                                                                <div className="menu-arrow">
                                                                    <a href='/rentdirect'><h2>Booking Engine | Discover <span>rent</span>direct</h2></a><img src="/img/arrow.png" alt=''/></div>
                                                                <div className="menu-right-inr">
                                                                    <div className="right-inr-left">
                                                                        <h3>key features</h3>
                                                                        <ul>
                                                                            <li><img src="/img/rent-direct-icon-one.svg" alt=''/><a href="/rentdirect#SmartBookingManagement">Smart Booking Management </a></li>
                                                                            <li><img src="/img/rent-direct-icon-two.svg" alt=''/><a href="/rentdirect#CustomerRelationshipTools">Customer Relationship Tools </a></li>
                                                                            <li><img src="/img/rent-direct-icon-three.svg" alt=''/><a href='/rentdirect#BrandedDigitalExperiences'>Branded Digital Experiences </a></li>
                                                                            <li><img src="/img/rent-direct-icon-four.svg" alt=''/><a href="/rentdirect#FinancialManagement">Financial Management</a></li>
                                                                            <li><img src="/img/rent-direct-icon-five.svg" alt=''/><a href='/rentdirect#fleettab2'>Fleet Management Center</a></li>
                                                                            <li><img src="/img/rent-direct-icon-six.svg" alt=''/><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li>
                                                                        </ul>
                                                                        <div className="join-cstm">
                                                                            <div className="join-text">
                                                                                <h3>Start for free and get rentid</h3>
                                                                                <p>From on-board to on-rent in less than 60 minutes.</p>
                                                                            </div>
                                                                            <Link to="https://app.rentid.io/sign-up">
                                                                                Get Started
                                                                                    </Link>
                                                                            {/* <button type="submit">join waitlist</button> */}
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-inr-right">
                                                                    <video width="100%" controls loop autoPlay muted playsInline>
                                                                    <source src="img/product-calander.mp4" type="video/mp4"/>
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                                        <h2>Modern rental tech for everyone</h2>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div id="tab-2" className="menu-right-tab">
                                                                    <div className="menu-arrow">
                                                                    <a href='/rent-id'><h2>Trust & Safety | Discover <span>rent</span>ID</h2></a><img src="/img/arrow.png" alt=''/></div>
                                                                <div className="menu-right-inr">
                                                                    <div className="right-inr-left">
                                                                        <h3>key features</h3>
                                                                        <ul>
                                                                            <li><img src="/img/rent-id-one.svg" alt=''/><a href="/rent-id#guestverification">Realtime Guest Verification</a></li>
                                                                            <li><img src="/img/rent-id-two.svg" alt=''/> <a href="/rent-id#NationalBlockListDatabase">National Blocklist Database </a></li>
                                                                            <li><img src="/img/rent-id-three.svg" alt=''/> <a href="/rent-id#AutoInsuranceValidation">Auto Insurance Validation</a></li>
                                                                            <li><img src="/img/rent-id-four.svg" alt=''/><a href="/rent-id#VerificationDashboard">Verification Dashbaord </a></li>
                                                                            <li><img src="/img/rent-id-five.svg" alt=''/> <a href="/rent-id#DriverIQScore">DriverIQ Score </a></li>
                                                                            <li><img src="/img/rent-id-six.svg" alt=''/><a href="/rent-id#RiskManagement">Risk Management</a></li>
                                                                        </ul>
                                                                        <div className="join-cstm">
                                                                            <div className="join-text">
                                                                                <h3>Start for free and get rentid</h3>
                                                                                <p>From on-board to on-rent in less than 60 minutes.</p>
                                                                            </div>
                                                                            <Link to="https://app.rentid.io/sign-up">Get Started</Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-inr-right">
                                                                        <video width="100%" controls loop autoPlay muted playsInline>
                                                                            <source src="img/video-2-product.mp4" type="video/mp4"/>
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                        <h2>Identify risk before it happens</h2>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div>
                                                            <div id="tab-3" className="menu-right-tab">
                                                                <div className="menu-arrow">
                                                                <a href='/rentshield'><h2>Insurance Coverages | Discover <span>rent</span>shield</h2></a><img src="/img/arrow.png" alt=''/></div>
                                                                <div className="menu-right-inr">
                                                                    <div className="right-inr-left">
                                                                        <h3>key features</h3>
                                                                        <ul>
                                                                            <li><img src="/img/rent-shield-one.svg" alt=''/><a href="/rentshield#CommercialAutoInsurance">Commercial Auto Insurance</a></li>
                                                                            <li><img src="/img/rent-shield-two.svg" alt=''/>
                                                                            <a href="/rentshield#DigitalClaimsManagement">Digital Claims Management </a></li>
                                                                            <li><img src="/img/rent-shield-three.svg" alt=''/> <a href="/rentshield#GuestProtectionPlans">Guest Protection Plans </a></li>
                                                                            <li><img src="/img/rent-shield-four.svg" alt=''/> <a href="/rentshield#CoverageSettings">Coverage Settings </a></li>
                                                                            <li><img src="/img/rent-shield-five.svg" alt=''/> <a href="/rentshield#NationalRoadsideAssistance">National Roadside Assistance </a></li>
                                                                            <li><img src="/img/rent-shield-six.svg" alt=''/> <a href="/rentshield#InsuranceServicesFAQ">Insurance Services FAQ </a></li>
                                                                        </ul>
                                                                        <div className="join-cstm">
                                                                            <div className="join-text">
                                                                                <h3>Start for free and get rentid</h3>
                                                                                <p>From on-board to on-rent in less than 60 minutes.</p>
                                                                            </div>
                                                                            <Link to="https://app.rentid.io/sign-up">Get Started</Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-inr-right">
                                                                    <video width="100%" controls loop autoPlay muted playsInline>
                                                                            <source src="img/video-4-product.mp4" type="video/mp4"/>
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                        <h2>Adding coverages made simple</h2>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div>
                                                            <div id="tab-4" className="menu-right-tab academytab">
                                                                <div className="menu-right-inr">
                                                                {/*  <a href="/rentai">
                                                                        <img src="/img/image6.png"/>
                                                                    </a> */}
                                                                    <div className="bannerAiOuter">
                                                                        <div className="row align-items-center">
                                                                        <div className="col-lg-5">
                                                                        <div className="bannerAiLeft">
                                                                        <small>AI Rental Task Agent</small>
                                                                        <h1> Meet rentii, your  rental task partner.</h1>
                                                                        <div className="menu-arrow">
                                                                        <a href="/rentai"><h2>Discover <span>rent</span>AI</h2>
                                                                        <img src="/img/arrow.png" alt=''/>
                                                                        </a>
                                                                        </div>
                                                                        </div>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                            <div id="tab-5" className="menu-right-tab">
                                                                <div className="menu-arrow">
                                                                <a href='/rentsuccess'><h2>Resolution & Support | Discover <span>rent</span>success</h2></a><img src="img/arrow.png" alt=''/></div>
                                                                <div className="menu-right-inr">
                                                                    <div className="right-inr-left">
                                                                        <h3>key features</h3>
                                                                        <ul>
                                                                            <li><img src="/img/rent-success-one.svg" alt=''/> <a href="/rentsuccess#ResolutionCenter">Resolution Center </a></li>
                                                                            <li><img src="/img/rent-success-two.svg" alt=''/> <a href='/rentsuccess#OnRentGuidelines'>On Rent Guidelines </a></li>
                                                                            <li><img src="/img/rent-success-three.svg" alt=''/> <a href="/rentsuccess#CancellationPolicies">Cancellation Policies </a></li>
                                                                            <li><img src="/img/rent-success-four.svg" alt=''/> <a href="/rentsuccess#TechnicalSupport">Technical Support </a></li>
                                                                            <li><img src="/img/rent-success-five.svg" alt=''/><a href='/rentsuccess#BusinessEmpowerment'>Business Empowerment </a></li>
                                                                            <li><img src="/img/rent-success-six.svg" alt=''/> <a href="/rentai">Rental Support Agent </a></li>
                                                                        </ul>
                                                                        <div className="join-cstm">
                                                                            <div className="join-text">
                                                                                <h3>Start for free and get rentid</h3>
                                                                                <p>From on-board to on-rent in less than 60 minutes.</p>
                                                                            </div>
                                                                            <Link to="https://app.rentid.io/sign-up">Get Started</Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-inr-right">
                                                                    <video width="100%" controls loop autoPlay muted playsInline>
                                                                            <source src="img/video-3-product.mp4" type="video/mp4"/>
                                                                            Your browser does not support the video tag.
                                                                        </video>
                                                                        <h2>Rental back office support</h2>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div id="tab-6" className="menu-right-tab ">
                                                                
                                                                <div className="menu-arrow">
                                                                <a href='/rentacademy'><h2>Education | Discover <span>rent</span>academy</h2></a><img src="img/arrow.png" alt=''/></div>
    
                                                                
                                                                <div className="menu-right-inr">
                                                                    <div className="right-inr-left">
                                                                        <h3>key features</h3>
                                                                        <ul>
                                                                            <li><img src="/img/rent-accademy-one.svg" alt=''/><a href="/rentacademy#welcomeAcademyMain">Rent Academy </a></li>
                                                                            <li><img src="/img/rent-accademy-two.svg" alt=''/> <a href="/rentacademy#video-library">Video Library </a> </li>
                                                                            <li><img src="/img/rent-accademy-three.svg" alt=''/> <a href="/rentacademy#nationalEventsAcademyMain">National Events </a></li>
                                                                            <li><img src="/img/rent-accademy-four.svg" alt=''/> <a href="/rentacademy#TrainingSupport">In App Resources </a></li>
                                                                            <li><img src="/img/rent-accademy-five.svg" alt=''/> <a href="/rentacademy#contentcreator">Behind the Wheel </a></li>
                                                                            <li><img src="/img/rent-accademy-six.svg" alt=''/><a href="/rentacademy#affiliatePartnerMain">Affiliate Program </a></li>
                                                                        </ul>
                                                                        <div className="join-cstm">
                                                                            <div className="join-text">
                                                                                <h3>Start for free and get rentid</h3>
                                                                                <p>From on-board to on-rent in less than 60 minutes.</p>
                                                                            </div>
                                                                            <Link to="https://app.rentid.io/sign-up">Get Started</Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="right-inr-right">
                                                                        <img src="/img/rent-image-accadmy.png" alt=''/>
                                                                        <h2>Learn more and do more</h2>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                      
                                         
                                      </div>
 
                                 </li>
                           
                                
                                 <li className="nav-item dropdown" >
                                     <button className="nav-link loginbtn nav-link dropdown-toggle product-links-menus" id="navbarDropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" >Back Office  
                                     <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> 
                                     <img src="/img/blue-icon.svg" className="blue-icon-drop" alt="icon" /> 
                                     </button>
                                     
                                 
                                     <div className="dropdown-menu open-full-mega" aria-labelledby="navbarDropdown">
                                        <div className="full-mega-menu feature-full-mega-menu">
                                            <div className="custom-menu">
                                                <div className="container">
                                                    <div className="feature-mega-box">
                                                <h3 className="d-none phone-lin-sol"><a href="/features">Features</a></h3> 
                                                    <h3 className="destop-heading-new-so"><a href="/features">Features</a></h3>  
                                                    
                                                    <div className="feature-list-items row">
                                                        
                                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                                                            <h4 >Operational <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /></h4>
                                                            <ul>
                                                                <li><img src="/img/feature-oper-nine.svg" alt="icon"/><a href="/rentdirect#SmartBookingManagement">Smart Booking Management</a></li>
                                                                <li><img src="/img/feature-oper-eight.svg" alt="icon"/><a href="/rentshield#GuestProtectionPlans">Guest Protection Plans</a></li>
                                                                <li><img src="/img/feature-oper-seven.svg" alt="icon"/><a href="/rentdirect#marketing_main">Guest Quotes</a></li>
                                                                <li><img src="/img/feature-oper-six.svg" alt="icon"/><a href="/rentdirect#tabMarketing_2">Discount Codes</a></li>
                                                                <li><img src="/img/feature-oper-five.svg" alt="icon"/><a href="/rentdirect#tabMarketing_3">In-app spotlight</a></li>
                                                                <li><img src="/img/feature-oper-four.svg" alt="icon"/><a href="/rentdirect#fleettab1">Booking Calendar</a></li>
                                                                <li><img src="/img/feature-oper-three.svg" alt="icon"/><a href="/rentsuccess#onRentGuidelines_2">Direct Communication</a></li>
                                                                <li><img src="/img/feature-oper-two.svg" alt="icon"/><a href="/rentdirect#fleettab3">Vehicle Profile</a></li>
                                                                <li><img src="/img/feature-oper-one.svg" alt="icon"/><a href="/rentai">Rental Support Agent</a></li>
                                                            </ul>
                                                        </div>
                                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                                                            <h4>Logistical <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /></h4>
                                                            <ul>
                                                                <li><img src="/img/feature-logist-icon-one.svg" alt="icon"/><a href='/rentdirect#fleettab2'>Fleet Management</a></li>
                                                                <li><img src="/img/feature-logist-icon-two.svg" alt="icon"/><a href="/primary-commericial#onRentMain">On-Rent Coverage</a></li>
                                                                <li><img src="/img/feature-logist-icon-three.svg" alt="icon"/><a href="/primary-commericial#offRentInsuranceMain">Off-Rent Coverage</a></li>
                                                                <li><img src="/img/feature-logist-icon-four.svg" alt="icon"/><a href="/rentdirect#fleettab4">Telematics</a></li>
                                                                <li><img src="/img/feature-logist-icon-six.svg" alt="icon"/><a href="/rentshield#NationalRoadsideAssistance">National Roadside Assistance</a></li>
                                                                <li><img src="/img/feature-logist-icon-seven.svg" alt="icon"/><a href="/rentsuccess#tolls_and_tickets">Tolls & Tickets</a></li>
                                                                <li><img src="/img/feature-logist-icon-nine.svg" alt="icon"/><a href="/primary-commericial#PersonalRental">Personal/ Leisure Rental</a></li>
                                                                <li><img src="/img/feature-logist-icon-eight.svg" alt="icon"/><a href="/primary-commericial#GigRental">Gig  Rental</a></li>
                                                                
                                                            </ul>
                                                        </div>
                                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                                                            <h4>Administrative <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /> </h4>
                                                            <ul>
                                                                <li><img src="/img/feature-admin-two.svg" alt="icon"/><a href="/rent-id#guestverification">Realtime Guest Verification</a></li>
                                                                <li><img src="/img/feature-admin-one.svg" alt="icon"/><a href="/rent-id#AutoInsuranceValidation">Auto Insurance Validation</a></li>
                                                                <li><img src="/img/feature-admin-three.svg" alt="icon"/><a href="/rent-id#DriverIQScore">DriverIQ Score</a></li>
                                                                <li><img src="/img/feature-admin-four.svg" alt="icon"/><a href="/rentdirect#customerRelationship_1">Review Management</a></li>
                                                                <li><img src="/img/feature-admin-five.svg" alt="icon"/><a href="/rentdirect#customerRelationship_3">Schedule Messages</a></li>
                                                                <li><img src="/img/feature-admin-six.svg" alt="icon"/><a href="/rentshield#CoverageSettings">Coverage Settings</a></li>
                                                                <li><img src="/img/feature-office-icon-five.svg" alt="icon"/><a href="/rentdirect#financialManagements_3">Payment Methods</a></li>
                                                                <li><img src="/img/feature-admin-seven.svg" alt="icon"/><a href="/rentdirect#financialManagements_1">Dynamic Invoices</a></li>
                                                                <li><img src="/img/feature-admin-eight.svg" alt="icon"/><a href="/rentdirect#financialManagements_2">Dynamic Agreement</a></li>
                                                                <li><img src="/img/feature-office-icon-seven.svg" alt="icon"/><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li>
                                                                
                                                            </ul>
                                                        </div>
                                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                                                            <h4>Resolution center <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /></h4>
                                                            <ul>
                                                                <li><img src="/img/feature-office-icon-one.svg" alt="icon"/><a href="/rentsuccess#refundpolicy">Refund Process</a></li>
                                                                <li><img src="/img/feature-office-icon-two.svg" alt="icon"/><a href="/rentsuccess#violations">Renter Violations</a></li>
                                                                <li><img src="/img/feature-office-icon-three.svg" alt="icon"/><a href="/rentsuccess#insurance_claims">Insurance Claims</a></li>
                                                                <li><img src="/img/feature-office-icon-four.svg" alt="icon"/><a href="/rentsuccess#guest_behaviors">Report Guests</a></li>
                                                                {/* <li><img src="/img/feature-office-icon-five.svg" alt="icon"/><a href="/rentdirect#financialManagements_3">Payment Methods</a></li> */}
                                                                <li><img src="/img/feature-office-icon-six.svg" alt="icon"/><a href="/rentshield#DigitalClaimsManagement">Digital Claims Management</a></li>
                                                                {/* <li><img src="/img/feature-office-icon-seven.svg" alt="icon"/><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li> */}
                                                                <li><img src="/img/feature-office-icon-eight.svg" alt="icon"/><a href="/rent-id#NationalBlockListDatabase">National BlockList Database</a></li>
                                                                <li><img src="/img/feature-office-icon-nine.svg" alt="icon"/><a href="/rentsuccess#CancellationPolicies">Cancellation Policy</a></li>
                                                            </ul>
                                                        </div>
        
                                                    </div>
        
                                                    <div className="join-waitlist-botm">
                                                        <div className="wait-list-contnt">
                                                        <h5>Start for free and get rentid</h5>
                                                        <p>From on-board to on-rent in less than 60 minutes.</p>
                                                        </div>
        
                                                        <Link to="https://app.rentid.io/sign-up">Get Started</Link>
                                                    </div>
        
        
                                                    </div>
                                                </div>  
                                            </div>
                                        </div>
                                      </div>
                                 </li>
 
                                 <li className="nav-item dropdown">
                                     <button className="nav-link loginbtn nav-link dropdown-toggle product-links-menus" id="navbarDropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" > Solutions 
                                     <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> 
                                     <img src="/img/blue-icon.svg" className="blue-icon-drop" alt="icon" /> 
                                     </button>
                                     
                                     <div className="dropdown-menu open-full-mega" aria-labelledby="navbarDropdown">
                                     
                                     <div className="full-mega-menu feature-full-mega-menu solutions-mega-menu">
                                        <div className="custom-menu">
                                            <div className="container">
                                            <div className="feature-mega-box">
                                                <h3 className="d-none phone-lin-sol">
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                    <a href="">Solutions</a>
                                                    </h3>  
                                                
                                                <div className="row solution-three-box">
                                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 sol-technology">
                                                        <h3><a href="/technology">Technology</a></h3>

                                                        <ul>
                                                            <li>
                                                                <a href="/platform"> 
                                                                    <img src="img/enter-prices-icon-three.svg" alt="Platform"/> 
                                                                    <div className="technolgy-text">
                                                                        <h5>Platform</h5>
                                                                        <p>From on-board to on-rent in less<br/> than 60 minutes, all in one place.</p>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/marketplace"> 
                                                                    <img src="img/enter-prices-icon-two.svg" alt="Platform"/> 
                                                                    <div className="technolgy-text">
                                                                        <h5>Marketplace</h5>
                                                                        <p>Your rental brand accessible to <br/>renters anywhere & everywhere</p>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="/enterprise">
                                                                    <img src="img/enter-prices-icon-one.svg" alt="Platform"/> 
                                                                    <div className="technolgy-text">
                                                                        <h5>Enterprise</h5>
                                                                        <p>Build with our rental workflows <br/>designed to scale any business.</p>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                            
                                                        </div>
    
                                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 sol-industry">
                                                            <div className="main-industy-box">
                                                            <h3><a href="/industry">Industry</a></h3>
                                                        
                                                            <div className="industry-list-links">
                                                                <ul>
                                                                <li><img src="/img/feature-logist-icon-one.svg" alt="icon"/> <a href="/car-rental">Car Rental</a></li> 
                                                                <li><img src="/img/solutions-icon-two.svg" alt="icon"/> <a href="/car-sharing">Car Sharing</a></li> <li><img src="/img/solutions-icon-three.svg" alt="icon"/> <a href="/ride-sharing">Ride Share</a></li>
                                                                <li><img src="/img/solutions-icon-four.svg" alt="icon"/> <a href="/delivery">Delivery Drivers</a></li>
                                                                <li><img src="/img/solutions-icon-five.svg" alt="icon"/> <a href="/auto-dealerships">Dealerships</a></li> 
                                                                <li><img src="/img/solutions-icon-six.svg" alt="icon"/> <a href="/service-repair">Service & Repair</a></li>  
                                                                </ul>
    
                                                                <ul>
                                                                <li><img src="/img/solutions-icon-seven.svg" alt="icon"/> <a href="/vacation-rental">Vacation Rental</a></li> 
                                                                <li><img src="/img/solutions-icon-eight.svg" alt="icon"/> <a href="/hotel-resort">Hotel & Resort</a></li>
                                                                <li><img src="/img/solutions-icon-nine.svg" alt="icon"/> <a href="/property-management">Property Mgmt</a></li>
                                                                <li><img src="/img/solutions-icon-ten.svg" alt="icon"/> <a href="/corporate">Corporate</a></li>
                                                                <li><img src="/img/solutions-icon-eleven.svg" alt="icon"/> <a href="/government">Government</a></li> 
                                                                <li><img src="/img/solutions-icon-twelve.svg" alt="icon"/> <a href="/education">Education</a></li>  
                                                            </ul>
                                                            </div>
                                                            </div>
                                                        </div>
    
                                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 sol-fleet-size">
                                                            <h3><a href="/fleets">Fleet Size</a></h3>
                                                            
                                                            <div className="fleet-size-list">
                                                                    
                                                                <ul>
                                                                    <li>
                                                                        <a href='/fleet-5'>
                                                                        <div className="fleet-inner-box">
                                                                        <img src="img/fleet-size-one.svg" alt="icon"/>
                                                                        <h5>1 - 5 </h5>
                                                                        <p>Vehicles</p>
                                                                        </div>
                                                                        </a>
                                                                    </li>
    
                                                                    <li>
                                                                    <a href='/fleet-25'>
                                                                    <div className="fleet-inner-box">
                                                                        <img src="img/fleet-size-two.svg" alt="icon"/>
                                                                        <h5>6 - 25 </h5>
                                                                        <p>Vehicles</p>
                                                                        </div>  
                                                                        </a>
                                                                    </li>
    
                                                                    <li>
                                                                    <a href='/fleet-50'>
                                                                    <div className="fleet-inner-box">
                                                                        <img src="img/fleet-size-three.svg" alt="icon"/>
                                                                        <h5>26 - 50</h5>
                                                                        <p>Vehicles </p>
        
                                                                        </div>
                                                                        </a>
                                                                    </li>
                                                                    
                                                                    <li>
                                                                    <a href='/fleet-100'>
                                                                    <div className="fleet-inner-box">
                                                                        <img src="img/fleet-size-four.svg" alt="icon"/>
                                                                        <h5>100+</h5>
                                                                        <p>Vehicles </p>
                                                                        </div>
                                                                        </a>
                                                                    </li>
    
                                                                </ul>   
                                                                
                                                            </div>
                                                            
                                                        </div>
                                                </div>
    
    
    
    
                                                <div className="join-waitlist-botm">
                                                    <div className="wait-list-contnt">
                                                    <h5>Start for free and get rentid</h5>
                                                    <p>From on-board to on-rent in less than 60 minutes.</p>
                                                    </div>
    
                                                    <Link to="https://app.rentid.io/sign-up">Get Started</Link>
                                                </div>
    
    
                                            </div>
                                        </div>
                                       </div>
                                      </div>
                                      
                                      
                                     </div>
 
 
                                 </li>
 
                                 
                                 <li className="nav-item dropdown">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                     <a className="nav-link loginbtn nav-link dropdown-toggle product-links-menus" id="navbarDropdown" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" href='#'> Resources 
                                        <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> 
                                        <img src="/img/blue-icon.svg" className="blue-icon-drop" alt="icon" /> 
                                     </a>
 
                                    
                                     <div className="dropdown-menu open-full-mega resources-menu-mega" aria-labelledby="navbarDropdown">
                                       <div className="full-mega-menu">
                                            <div className="custom-menu">
                                            <div className="container">
                                               <div className="learn-suport-section row">
                                                     
                                                     <div className="col-xl-7 col-lg-8 col-md-7 col-sm-12 learn-support-content">
                                                         <div className="row">
                                                             <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                                 <h5> <a href="/learn">Learn</a></h5>
                                                                 <ul>
                                                                     <li>
                                                                       <a href="/about-us"><img src="img/learn-res-icon-one.svg" alt="icon"/> 
                                                                         <div className="content-lea-support">
                                                                             <h3>About Us</h3>
                                                                             <p>Discover our mission, values, and how we empower users with innovative solutions.</p>
                                                                         </div>
                                                                       </a>
                                                                       </li>
                                                                       <li>
                                                                       <a href="/rentacademy#video-library"><img src="img/learn-res-icon-two.svg" alt="icon"/> 
                                                                         <div className="content-lea-support">
                                                                             <h3>Videos Library </h3>
                                                                             <p>Browse helpful tutorials, guides, and insights to maximize your experience.</p>
                                                                         </div>
                                                                       </a>
                                                                       </li>
 
                                                                       <li className="resources_menu">
                                                                      <span><img src="img/learn-res-icon-three.svg" alt="icon"/>
                                                                        <div className="content-lea-support">
                                                                            <h3>Resource Center <span className="comin-btn-new">Coming Soon</span></h3>
                                                                            <p>Essential tools and support to help hosts manage their rentals efficiently.</p>
                                                                        </div>
                                                                      </span>
                                                                      </li>
                                                                       <li>
                                                                       <a href="/blogs"><img src="img/learn-res-icon-four.svg" alt="icon"/> 
                                                                         <div className="content-lea-support">
                                                                             <h3>Blog</h3>
                                                                             <p>Stay informed with industry insights, expert advice, and platform updates.</p>
                                                                         </div>
                                                                       </a>
                                                                       </li>
                                                                 </ul>
                                                             </div>
 
 
                                                             <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                                 <h5> <a href="/support">Support</a></h5>
                                                                 <ul>
                                                                     <li>
                                                                       <span role="button" tabIndex={0} onClick={() => handleNavigation("support")} onKeyDown={(e) => e.key === 'Enter' && handleNavigation("support")}><img src="img/support-res-icon-one.svg" alt="icon"/>
                                                                         <div className="content-lea-support">
                                                                             <h3>FAQs</h3>
                                                                             <p>Find answers to common questions about our platform, policies, & features.</p>
                                                                         </div>
                                                                       </span>
                                                                       </li>
                                                                       <li>
                                                                       <a href="/rentsuccess#businessEmpowerment_2"><img src="img/support-res-icon-two.svg" alt="icon"/>
                                                                         <div className="content-lea-support">
                                                                             <h3>Success Manager  </h3>
                                                                             <p>Personalized support to help you optimize & grow your rental business.</p>
                                                                         </div>
                                                                       </a>
                                                                       </li>

                                                                       <li className="resources_menu">
                                                                      <span><img src="img/support-res-icon-three.svg" alt="icon"/>
                                                                        <div className="content-lea-support">
                                                                            <h3>Marketing Team <span className="comin-btn-new">Coming Soon</span></h3>
                                                                            <p>Strategies and resources to enhance visibility and attract more customers.</p>
                                                                        </div>
                                                                      </span>
                                                                      </li>
                                                                       <li>
                                                                       <a href="/general-question"><img src="img/support-res-icon-four.svg" alt="icon"/> 
                                                                         <div className="content-lea-support">
                                                                             <h3>Contact Us</h3>
                                                                             <p>Reach out for assistance—we're here to support you every step of the way..</p>
                                                                         </div>
                                                                       </a>
                                                                       </li>
                                                                 </ul>
                                                             </div>
 
 
                                                         </div>
                                                     </div>
                                                       
                                                     <div className="col-xl-5 col-lg-4 col-md-5 col-sm-12 text-end">
                                                         <img src="/img/resource-mega-ig.png" className="res-im img-fluid" alt="resources"/>
                                                     </div>
                                               </div> 
                                            </div>
                                          </div>
                                       </div>
                                     </div>
                                 </li>                            
 
                                 
                             </ul>

                    <ul className="navbar-nav ms-auto btn-inside-contact">
                             <li className="nav-item pricing-menu-top">
                                     <a className="nav-link" href='/#plans'>Pricing</a>
                            </li> 
                       </ul>
                    <ul className="navbar-nav ms-auto all-btns-insite0logins">
                    <li className="nav-item drop-contc-mobile pricing-menu-top">
                                    <a className="nav-link" href='/#plans'>Pricing</a>
                                </li>
                                <li className="nav-item drop-contc-mobile">
                                    <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                                </li>
                        <li className="nav-item nav-itemBtn">
                        <Link to="https://app.rentid.io/sign-up" className="btn joinWaitBtn">Start for free</Link>
                        </li>
                        <li className="nav-item dropdown login-last-link">
                            <a className="loginbtn login-icon nav-link inner-login" href="https://app.rentid.io/login" aria-label="Login" title="Login"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg></a>
                        </li>
                        {/* {process.env.REACT_APP_ENABLE_BETA === "true" && (<li className="nav-item nav-itemBtn">
                            <button className="btn getStartedBtn" onClick={() => {
                                navigate('/?signup=beta-program')
                            }}>Join Beta</button>
                        </li>)} */}

                    </ul>

                      
                    <ul className="navbar-nav ms-auto footer-menu-mobile-new "> 
                                <li className="nav-item">
                                    <a className="nav-link" href='/contact-us' >Contact Sales</a>
                                </li>
                                <li className="nav-item pricing-menu-top">
                                    <span className="nav-link">View Demo</span>
                                </li>
                                <li className="nav-item pricing-menu-top">
                                    <span className="nav-link">Download App</span>
                                </li>
                    </ul>



                    <ul className="navbar-nav ms-auto footer-menu-mobile ">
                        <li className="nav-item">
                            <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                        </li>
                       <li className="nav-item dropdown">
                            <a className="loginbtn login-icon nav-link" href="https://app.rentid.io/login" aria-label="Login" title="Login"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg></a>
                        </li>
                    </ul>

                </div>

                <div className="collapse navbar-collapse mobile-header" id="navbarSupportedContentmob">
                         
                                                  
        <div className="menu">
            <button className='open_sub_btn' data-id='0'>
            <span>Products   <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> </span>
            </button>
            <button className='open_sub_btn' data-id='1'>     <span>Back Office   <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> </span></button>
            <button className='open_sub_btn' data-id='2'>     <span>Solutions   <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> </span></button>
            <button className='open_sub_btn' data-id='3'>     <span>Resources   <img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon" /> </span></button>
        </div>

        <div id="submenu-container" className="submenu-container">
          <div className="submenu product-menu" id="submenu-0" style={{ display: 'none', transform: 'translateX(100%)' }}>
                <button className="back-btn back-btn-close-b" data-id="0"><img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon"/> Back</button>
                <h3 className="menu-title">PRODUCTS</h3>
                <ul className="phone-menu">
                    <li>
                        <a href='/rentdirect'><button className="dropdown-item" type="button">
                            <img src='/img/rent_direct_h.svg' alt="icon" width={24} />
                            <div className="drop-content-item"><span>rent</span>direct <p>Every aspect of vehicle rental, fully automated.</p></div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a href='/rent-id'><button className="dropdown-item" type="button">
                                
                                <img src='/img/rent_id_h.svg' alt="icon" width={24} />
                                <div className="drop-content-item"> <span>rent</span>ID
                                <p>Trust & safety tools to minimize rental risk.</p>
                                </div>
                                </button>
                            
                        </a>
                    </li>
                    <li>
                        <a href='/rentshield'><button className="dropdown-item" type="button">
                            
                            
                                <img src='/img/rent_shield_h.svg' alt="icon" width={24} />
                                <div className="drop-content-item"> <span>rent</span>shield
                                <p>Embedded insurance and protection plans.</p>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a href='/rentai'><button className="dropdown-item" type="button">

                                
                                <img src='/img/rent_ai_h.svg' alt="icon" width={24} />
                                <div className="drop-content-item"> <span>rent</span>AI
                                <p>Done for you rental tasks & workflows</p>
                                </div>

                            </button>
                        </a>
                    </li>
                    <li>
                        <a href='/rentsuccess'>
                        <button className="dropdown-item" type="button">
                                
                                <img src='/img/rent_success_h.svg' alt="icon" width={24} />
                                <div className="drop-content-item"> 
                                <span>rent</span>success
                                <p>Support, resolutions, & customer satisfaction.</p>
                                </div>
                            </button>
                        </a>
                    </li>
                    <li>
                        <a href='/rentacademy'>
                            <button className="dropdown-item" type="button">
                                <img src='/img/rent_academy_h.svg' alt="icon" width={24} />
                                <div className="drop-content-item"> <span>rent</span>academy
                                <p>Drive growth, maximize potential, & stay informed.</p>
                                </div>
                            </button>
                        </a>
                    </li>
                </ul>
                <ul className="navbar-nav ms-auto footer-menu-mobile-new ">
                    <li className="nav-item">
                        <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                    </li>
                </ul>
            </div>

            <div className="submenu" id="submenu-1" style={{ display: 'none', transform: 'translateX(100%)' }}>
                <button className="back-btn back-btn-close-b" data-id="1"><img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon"/>Back</button>
                <h3 className="menu-title"><a href="/features">features</a></h3>

                <div className="feature-list-items row">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                    <h4 >Operational <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /></h4>
                    <ul>
                        <li><img src="/img/feature-oper-nine.svg" alt="icon"/><a href="/rentdirect#SmartBookingManagement">Smart Booking Management</a></li>
                        <li><img src="/img/feature-oper-eight.svg" alt="icon"/><a href="/rentshield#GuestProtectionPlans">Guest Protection Plans</a></li>
                        <li><img src="/img/feature-oper-seven.svg" alt="icon"/><a href="/rentdirect#marketing_main">Guest Quotes</a></li>
                        <li><img src="/img/feature-oper-six.svg" alt="icon"/><a href="/rentdirect#tabMarketing_2">Discount Codes</a></li>
                        <li><img src="/img/feature-oper-five.svg" alt="icon"/><a href="/rentdirect#tabMarketing_3">In-app spotlight</a></li>
                        <li><img src="/img/feature-oper-four.svg" alt="icon"/><a href="/rentdirect#FleetManagementCenter">Booking Calendar</a></li>
                        <li><img src="/img/feature-oper-three.svg" alt="icon"/><a href="/rentsuccess#onRentGuidelines_2">Direct Communication</a></li>
                        <li><img src="/img/feature-oper-two.svg" alt="icon"/><a href="/rentdirect#fleettab3">Vehicle Profile</a></li>
                        <li><img src="/img/feature-oper-one.svg" alt="icon"/><a href="/rentai">Rental Support Agent</a></li>
                    </ul>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                    <h4>Logistical <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /></h4>
                    <ul>
                        <li><img src="/img/feature-logist-icon-one.svg" alt="icon"/><a href='/rentdirect#fleettab2'>Fleet Management</a></li>
                        <li><img src="/img/feature-logist-icon-two.svg" alt="icon"/><a href="/primary-commericial#onRentMain">On-Rent Coverage</a></li>
                        <li><img src="/img/feature-logist-icon-three.svg" alt="icon"/><a href="/primary-commericial#offRentInsuranceMain">Off-Rent Coverage</a></li>
                        <li><img src="/img/feature-logist-icon-four.svg" alt="icon"/><a href="/rentdirect#fleettab4">Telematics</a></li>
                        <li><img src="/img/feature-logist-icon-six.svg" alt="icon"/><a href="/rentshield#NationalRoadsideAssistance">National Roadside Assistance</a></li>
                        <li><img src="/img/feature-logist-icon-seven.svg" alt="icon"/><a href="/rentsuccess#tolls_and_tickets">Tolls & Tickets</a></li>
                        <li><img src="/img/feature-logist-icon-nine.svg" alt="icon"/><a href="/primary-commericial#PersonalRental">Personal/ Leisure Rental</a></li>
                        <li><img src="/img/feature-logist-icon-eight.svg" alt="icon"/><a href="/primary-commericial#GigRental">Gig Rental</a></li>
                    </ul>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                    <h4>Administrative <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /> </h4>
                    <ul>
                        <li><img src="/img/feature-admin-two.svg" alt="icon"/><a href="/rent-id#guestverification">Realtime Guest Verification</a></li>
                        <li><img src="/img/feature-admin-one.svg" alt="icon"/><a href="/rent-id#AutoInsuranceValidation">Auto Insurance Validation</a></li>
                        <li><img src="/img/feature-admin-three.svg" alt="icon"/><a href="/rent-id#DriverIQScore">DriverIQ Score</a></li>
                        <li><img src="/img/feature-admin-four.svg" alt="icon"/><a href="/rentdirect#customerRelationship_1">Review Management</a></li>
                        <li><img src="/img/feature-admin-five.svg" alt="icon"/><a href="/rentdirect#customerRelationship_3">Schedule Messages</a></li>
                        <li><img src="/img/feature-admin-six.svg" alt="icon"/><a href="/rentshield#CoverageSettings">Coverage Settings</a></li>
                        <li><img src="/img/feature-office-icon-five.svg" alt="icon"/><a href="/rentdirect#financialManagements_3">Payment Methods</a></li>
                        <li><img src="/img/feature-admin-seven.svg" alt="icon"/><a href="/rentdirect#financialManagements_1">Dynamic Invoices</a></li>
                        <li><img src="/img/feature-admin-eight.svg" alt="icon"/><a href="/rentdirect#financialManagements_2">Dynamic Agreement</a></li>
                        <li><img src="/img/feature-office-icon-seven.svg" alt="icon"/><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li>
                        
                    </ul>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 feature-list-arrow-hover">
                    <h4>Resolution center <img src="/img/dropdown-icon.svg" className="blue-icon-drop d-none" alt="icon" /></h4>
                    <ul>
                        <li><img src="/img/feature-office-icon-one.svg" alt="icon"/><a href="/rentsuccess#refundpolicy">Refund Process</a></li>
                        <li><img src="/img/feature-office-icon-two.svg" alt="icon"/><a href="/rentsuccess#violations">Renter Violations</a></li>
                        <li><img src="/img/feature-office-icon-three.svg" alt="icon"/><a href="/rentsuccess#insurance_claims">Insurance Claims</a></li>
                        <li><img src="/img/feature-office-icon-four.svg" alt="icon"/><a href="/rentsuccess#guest_behaviors">Report Guests</a></li>
                        {/* <li><img src="/img/feature-office-icon-five.svg" alt="icon"/><a href="/rentdirect#financialManagements_3">Payment Methods</a></li> */}
                        <li><img src="/img/feature-office-icon-six.svg" alt="icon"/><a href="/rentshield#DigitalClaimsManagement">Digital Claims Management</a></li>
                        {/* <li><img src="/img/feature-office-icon-seven.svg" alt="icon"/><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li> */}
                        <li><img src="/img/feature-office-icon-eight.svg" alt="icon"/><a href="/rent-id#NationalBlockListDatabase">National BlockList Database</a></li>
                        <li><img src="/img/feature-office-icon-nine.svg" alt="icon"/><a href="/rentsuccess#CancellationPolicies">Cancellation Policy</a></li>
                    </ul>
                    </div>
                </div>

                <ul className="navbar-nav ms-auto footer-menu-mobile-new ">
                    <li className="nav-item">
                        <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                    </li>
                </ul>
            </div>

            <div className="submenu" id="submenu-2" style={{ display: 'none', transform: 'translateX(100%)' }}>
                <button className="back-btn back-btn-close-b" data-id="2"><img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon"/>Back</button>
                <h3 className="menu-title"><span>solutions</span></h3>
                <div className="feature-mega-box">
                    <div className="row solution-three-box">
                            
                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 sol-technology">
                            <h3><a href="/technology">Technology</a></h3>

                            <ul>
                                    
                                    <li>
                                        <a href="/platform"> 
                                            <img src="img/enter-prices-icon-three.svg" alt="Platform"/> 
                                            <div className="technolgy-text">
                                                <h5>Platform</h5>
                                                <p>From on-board to on-rent in less<br/> than 60 minutes, all in one place.</p>
                                            </div>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="/marketplace"> 
                                            <img src="img/enter-prices-icon-two.svg" alt="Platform"/> 
                                            <div className="technolgy-text">
                                                <h5>Marketplace</h5>
                                                <p>Your rental brand accessible to <br/>renters anywhere & everywhere</p>
                                            </div>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="/enterprise"> 
                                            <img src="img/enter-prices-icon-one.svg" alt="Platform"/> 
                                            <div className="technolgy-text">
                                        <h5>Enterprise</h5>
                                        <p>Build with our rental workflows <br/>designed to scale any business.</p>
                                        </div> 
                                        </a>
                                    </li>

                            </ul>
                                
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 sol-industry">
                                <div className="main-industy-box">
                                <h3><a href="/industry">Industry</a></h3>
                                
                                <div className="industry-list-links">
                                    <ul>
                                    <li><img src="/img/feature-logist-icon-one.svg" alt="icon"/> <a href="/car-rental">Car Rental</a></li> 
                                    <li><img src="/img/solutions-icon-two.svg" alt="icon"/> <a href="/car-sharing">Car Sharing</a></li> <li><img src="/img/solutions-icon-three.svg" alt="icon"/> <a href="/ride-sharing">Ride Share</a></li>
                                    <li><img src="/img/solutions-icon-four.svg" alt="icon"/> <a href="/delivery">Delivery Drivers</a></li>
                                    <li><img src="/img/solutions-icon-five.svg" alt="icon"/> <a href="/auto-dealerships">Dealerships</a></li> 
                                    <li><img src="/img/solutions-icon-six.svg" alt="icon"/> <a href="/service-repair">Service & Repair</a></li>  
                                    </ul>

                                    <ul>
                                    <li><img src="/img/solutions-icon-seven.svg" alt="icon"/> <a href="/vacation-rental">Vacation Rental</a></li> 
                                    <li><img src="/img/solutions-icon-eight.svg" alt="icon"/> <a href="/hotel-resort">Hotel & Resort</a></li> 
                                    <li><img src="/img/solutions-icon-nine.svg" alt="icon"/> <a href="/property-management">Property Mgmt</a></li>
                                    <li><img src="/img/solutions-icon-ten.svg" alt="icon"/> <a href="/corporate">Corporate</a></li>
                                    <li><img src="/img/solutions-icon-eleven.svg" alt="icon"/> <a href="/government">Government</a></li> 
                                    <li><img src="/img/solutions-icon-twelve.svg" alt="icon"/> <a href="/education">Education</a></li>  
                                    </ul>
                                </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 sol-fleet-size">
                                <h3><a href="/fleets">Fleet Size</a></h3>
                                
                                <div className="fleet-size-list">
                                        
                                    <ul>
                                            <li>
                                            <a href='/fleet-5'>
                                            <div className="fleet-inner-box">
                                                <img src="img/fleet-size-one.svg" alt="icon"/>
                                                <h5>1 - 5 </h5>
                                                <p>Vehicles</p>
                                                </div>
                                                </a>
                                            </li>

                                            <li>
                                            <a href='/fleet-25'>
                                            <div className="fleet-inner-box">
                                                <img src="img/fleet-size-two.svg" alt="icon"/>
                                                <h5>6 - 25 </h5>
                                                <p>Vehicles</p>
                                            </div>  
                                            </a>
                                            </li>

                                            <li>
                                            <a href='/fleet-50'>
                                            <div className="fleet-inner-box">
                                                <img src="img/fleet-size-three.svg" alt="icon"/>
                                                <h5>26 - 50</h5>
                                                <p>Vehicles </p>
                                                </div>
                                                </a>
                                            </li>
                                            
                                            <li>
                                            <a href='/fleet-100'>
                                            <div className="fleet-inner-box">
                                                <img src="img/fleet-size-four.svg" alt="icon"/>
                                                <h5>100+</h5>
                                                <p>Vehicles </p>
                                                </div>
                                                </a>
                                            </li>

                                    </ul>   
                                    
                                </div>
                                
                            </div>
                    </div>
                </div>

                <ul className="navbar-nav ms-auto footer-menu-mobile-new ">
                    <li className="nav-item">
                        <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                    </li>
                </ul>
            </div>
            <div className="submenu" id="submenu-3" style={{ display: 'none', transform: 'translateX(100%)' }}>
                <button className="back-btn back-btn-close-b" data-id="3"><img className="white-icon-dropdown" src="/img/arrow-down.svg" alt="icon"/>Back</button>
                <div className="learn-suport-section row">
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-6 learn-support-content">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <h3 className="menu-title"><a href="/learn">learn</a></h3>
                                <ul>
                                    <li>
                                        <a href="/about-us"><img src="img/learn-res-icon-one.svg" alt="icon"/> 
                                        <div className="content-lea-support">
                                            <h3>About Us</h3>
                                            <p>Discover our mission, values, and how we empower users with innovative solutions.</p>
                                        </div>
                                        </a>
                                        </li>
                                        <li>
                                        <a href="/rentacademy#video-library"><img src="img/learn-res-icon-two.svg" alt="icon"/> 
                                        <div className="content-lea-support">
                                            <h3>Videos Library </h3>
                                            <p>Browse helpful tutorials, guides, and insights to maximize your experience.</p>
                                        </div>
                                        </a>
                                        </li>

                                        <li className="resources_menu">
                                        <span><img src="img/learn-res-icon-three.svg" alt="icon"/>
                                        <div className="content-lea-support">
                                            <h3>Resource Center <span className="comin-btn-new">Coming Soon</span></h3>
                                            <p>Essential tools and support to help hosts manage their rentals efficiently.</p>
                                        </div>
                                        </span>
                                        </li>
                                        <li>
                                        <a href="/blogs"><img src="img/learn-res-icon-four.svg" alt="icon"/>
                                        <div className="content-lea-support">
                                            <h3>Blog</h3>
                                            <p>Stay informed with industry insights, expert advice, and platform updates.</p>
                                        </div>
                                        </a>
                                        </li>
                                </ul>
                            </div>


                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                <h3 className="menu-title support"><a href="/support">support</a></h3>
                                <ul>
                                    <li>
                                        <span role="button" tabIndex={0} onClick={() => handleNavigation("support")} onKeyDown={(e) => e.key === 'Enter' && handleNavigation("support")}><img src="img/support-res-icon-one.svg" alt="icon"/>
                                        <div className="content-lea-support">
                                            <h3>FAQs</h3>
                                            <p>Find answers to common questions about our platform, policies, & features.</p>
                                        </div>
                                        </span>
                                        </li>
                                        <li>
                                        <a href="/rentsuccess#businessEmpowerment_2"><img src="img/support-res-icon-two.svg" alt="icon"/>
                                        <div className="content-lea-support">
                                            <h3>Success Manager  </h3>
                                            <p>Personalized support to help you optimize & grow your rental business.</p>
                                        </div>
                                        </a>
                                        </li>

                                        <li className="resources_menu">
                                        <span><img src="img/support-res-icon-three.svg" alt="icon"/>
                                        <div className="content-lea-support">
                                            <h3>Marketing Team <span className="comin-btn-new">Coming Soon</span></h3>
                                            <p>Strategies and resources to enhance visibility and attract more customers.</p>
                                        </div>
                                        </span>
                                        </li>
                                        <li>
                                        <a href="/general-question"><img src="img/support-res-icon-four.svg" alt="icon"/> 
                                        <div className="content-lea-support">
                                            <h3>Contact Us</h3>
                                            <p>Reach out for assistance—we're here to support you every step of the way..</p>
                                        </div>
                                        </a>
                                        </li>
                                </ul>
                            </div>


                        </div>
                    </div>
                </div>

                <ul className="navbar-nav ms-auto footer-menu-mobile-new ">
                    <li className="nav-item">
                        <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                    </li>
                </ul>
            </div>
        </div>


                       <ul className="navbar-nav ms-auto btn-inside-contact">
                             <li className="nav-item pricing-menu-top">
                                     <a className="nav-link" href='/#plans'>Pricing</a>
                            </li> 
                            <li className="nav-item pricing-menu-top joinbtn-menu">
                            <Link to="https://app.rentid.io/sign-up" className="btn joinWaitBtn">Start for free</Link>
                            </li>
                       </ul>
                            <ul className="navbar-nav ms-auto all-btns-insite0logins">
                                <li className="nav-item drop-contc-mobile pricing-menu-top">
                                    <a className="nav-link" href='/#plans'>Pricing</a>
                                </li>
                                <li className="nav-item drop-contc-mobile">
                                    <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                                </li>
                                <li className="nav-item nav-itemBtn">
                                    <Link to="https://app.rentid.io/sign-up" className="btn joinWaitBtn">Start for free</Link>
                                </li>
                                <li className="nav-item dropdown last-link-new-btn">
                                    <a className="loginbtn login-icon nav-link" href="https://app.rentid.io/login" aria-label="Login" title="Login"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg></a>
                                </li>
                                {/* {process.env.REACT_APP_ENABLE_BETA === "true" && ( */}
                                    {/* <li className="nav-item nav-itemBtn">
                                        <button className="btn getStartedBtn" data-bs-toggle="modal" data-bs-target="#exampleModal">Join Beta</button>
                                    </li> */}
                                {/* )} */}

                            </ul>
                             
                            <ul className="navbar-nav ms-auto footer-menu-mobile-new ">
                                <li className="nav-item">
                                    <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                                </li>

                            </ul>




                               <ul className="navbar-nav ms-auto footer-menu-mobile ">
                                                  <li className="nav-item">
                                                      <a className="nav-link bookDemoBtn" href='https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew' target="_blank" rel="noopener noreferrer">Book Demo</a>
                                                  </li>
                                                 {/* <li className="nav-item dropdown">
                                                      <button className="loginbtn nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                          Login <img src="/img/arrow-down-blue.svg" alt="Expand Login Menu" />
                                                      </button>
                                                      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                          <li><Link to='/guest' ><button className="dropdown-item" type="button"> <img src={guestimg} alt="Guest Login" className="" width={24} />Login as Guest</button></Link></li>
                                                          <li> <Link to='/host'><button className="dropdown-item" type="button"><img src={hostimg} alt="Host Login" className="" width={24} />Login as Host</button></Link></li>
                                                      </ul>
                                                  </li> */}
                            </ul>


                        
                        </div>
                        
            </nav>
            
        </div>
        </header>
        {/* END header */} 

            <BetaForm />

        </div>
    );
};

export default Aiheader;
